import React from "react";

const NoModes = () => {
  return (
    <div className="jumbotron justify-content-center">
      <h3 className="h3 text-center text-primary">No Payment Modes</h3>
    </div>
  );
};

export default NoModes;
